import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect opacity="0.01" width="24" height="24" fill="#D8D8D8" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM10.9482 17.8854C10.9482 17.3055 11.4183 16.8354 11.9982 16.8354C12.5781 16.8354 13.0482 17.3055 13.0482 17.8854C13.0482 18.2606 12.8481 18.6072 12.5232 18.7948C12.1984 18.9823 11.7981 18.9823 11.4732 18.7948C11.1484 18.6072 10.9482 18.2606 10.9482 17.8854ZM12.0059 4.99951C11.349 4.99951 10.8221 5.54243 10.8418 6.19897L11.0789 14.0999C11.0939 14.6011 11.5045 14.9995 12.0058 14.9995C12.5072 14.9995 12.9178 14.6011 12.9328 14.0999L13.1699 6.19897C13.1896 5.54243 12.6627 4.99951 12.0059 4.99951Z"
      fill="currentColor"
    />
    <mask
      id="mask0"
      type="alpha"
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="24"
      height="24"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM10.9482 17.8854C10.9482 17.3055 11.4183 16.8354 11.9982 16.8354C12.5781 16.8354 13.0482 17.3055 13.0482 17.8854C13.0482 18.2606 12.8481 18.6072 12.5232 18.7948C12.1984 18.9823 11.7981 18.9823 11.4732 18.7948C11.1484 18.6072 10.9482 18.2606 10.9482 17.8854ZM12.0059 4.99951C11.349 4.99951 10.8221 5.54243 10.8418 6.19897L11.0789 14.0999C11.0939 14.6011 11.5045 14.9995 12.0058 14.9995C12.5072 14.9995 12.9178 14.6011 12.9328 14.0999L13.1699 6.19897C13.1896 5.54243 12.6627 4.99951 12.0059 4.99951Z"
        fill="white"
      />
    </mask>
    <g mask="url(#mask0)"></g>
  </svg>
);
